import { render, staticRenderFns } from "./BaseDropDown.vue?vue&type=template&id=2b46f578&"
import script from "./BaseDropDown.vue?vue&type=script&lang=js&"
export * from "./BaseDropDown.vue?vue&type=script&lang=js&"
import style0 from "./BaseDropDown.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports